import { Box, Theme, Typography } from '@mui/material'
import ModalMui from '@mui/material/Modal'
import CloseIcon from '@mui/icons-material/Close'
import useEmotionStyles from 'hooks/useEmotionStyles'
import { useState } from 'react'

const styles = (theme: Theme) => ({
  contentStyle: {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: `calc(100% - ${theme.spacing(2)})`,
    maxWidth: 600,
    borderRadius: theme.spacing(0.5),
    outline: 'none',
    background: theme.palette.common.white,
    padding: theme.spacing(2)
  },
  titleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2)
  }
})

interface Props {
  children: React.ReactElement
  title: string
  content?: React.ReactElement
}

export const Modal = ({ children, content, title }: Props) => {
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const { contentStyle, titleRow } = useEmotionStyles(styles)

  return (
    <>
      <span onClick={handleOpen}>{children}</span>
      <ModalMui open={open} onClose={handleClose}>
        <Box className={contentStyle}>
          <div className={titleRow}>
            <Typography variant="h3">{title}</Typography>
            <CloseIcon
              onClick={handleClose}
              color="disabled"
              fontSize="medium"
              aria-label="close"
              cursor="pointer"
            />
          </div>
          {content}
        </Box>
      </ModalMui>
    </>
  )
}
